import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app-core/services/common.service';
import * as moment from 'moment';
import { finalize } from 'rxjs/operators';
import { JobsService } from 'src/app/jobs/jobs.service';
import { QuotesService } from 'src/app/quotes/quotes.service';

@Component({
  selector: 'app-orders-activity-list',
  templateUrl: './orders-activity-list.component.html',
  styleUrls: ['./orders-activity-list.component.scss']
})
export class OrdersActivityListComponent implements OnInit {
  orderId: string;
  activityList: any;
  isQuote: boolean;
  assignedTo: any;

  constructor(
    private location: Location,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private jobsService: JobsService,
    private quotesService: QuotesService,
  ) {
    if (this.activatedRoute.snapshot.queryParams.jobId) {
      this.orderId = this.activatedRoute.snapshot.queryParams.jobId;
      this.isQuote = false;
    } else if (this.activatedRoute.snapshot.queryParams.quoteId) {
      this.orderId = this.activatedRoute.snapshot.queryParams.quoteId;
      this.isQuote = true;
    }
    this.getOrderDetails();
  }

  searchQuery: string;
  filterSelectedValue: any;
  employees: any = [];
  userId = this.commonService.getUserId();
  employeeId: any;
  datePicker: any;
  dateFilter: any;
  isShowLoading = false;

  // this is till API is not ready
  activityFilterList = [
    { id: 0, name: 'None' },
    { id: 1, name: 'Jobs' },
    { id: 2, name: 'Quotes' }
  ];

  getOrderDetails() {
    if (this.isQuote) {
      this.quotesService.getQuote(this.orderId).subscribe(response => {
        this.assignedTo = response.data.assignedTo;
        this.getEmployees();
        this.getOrderActivityLogs();
      });
    } else {
      this.jobsService.getJob(this.orderId).subscribe(response => {
        this.assignedTo = response.data.assignedTo;
        this.getEmployees();
        this.getOrderActivityLogs();
      });
    }
  }

  getOrderActivityLogs() {
    var request = "OrderId=" + this.orderId;
    if (this.assignedTo) {
      request += `&IncludeEmployee=${this.assignedTo}`
    }
    if (this.employeeId) {
      request += `&employeeId=${this.employeeId}&`;
    }
    if (this.searchQuery) {
      request += `&SearchKey=${this.searchQuery}`;
    }
    if (this.datePicker) {
      request += `&DateSearchkey=${this.dateFilter}`;
    }
    this.isShowLoading = true;
    this.commonService.getOrderActivityLogs(request)
      .pipe(finalize(() => (this.isShowLoading = false))).subscribe(response => {
        if (response.isSuccess) {
          this.activityList = response.data;
        }
      });
  }

  getEmployees(): void {
    this.commonService.getEmployees(this.assignedTo || 0).subscribe(response => {
      if (response.isSuccess) {
        this.employees = response.data;
      }
    });
  }

  // this is till API is not ready
  activityTypeEnum = {
    love: 'favorite',
    account: 'account_circle',
    check: 'check_circle',
    security: 'security',
    boll: 'sports_volleyball'
  }

  ngOnInit() {
    this.filterSelectedValue = this.activityFilterList.filter(item => item.id === 0);
  }

  onFiltersChange(event: any) {
    if (event.assignedTo) {
      this.employeeId = event.assignedTo;
      this.getOrderActivityLogs();
    }
  }

  onClearSearch(): void {
    this.searchQuery = null;
    this.getOrderActivityLogs();
  }

  onChangeDate(event: any) {
    this.dateFilter = moment(event.value).format("MM/DD/YYYY");
    this.getOrderActivityLogs();
  }

  onSearch(): void {
    if (this.searchQuery) {
    }
  }

  onSearchChange(): void {
    if (!this.searchQuery) {
    } else if (this.searchQuery.length > 2) {
      this.getOrderActivityLogs();

    }
  }

  resetDateFilter() {
    this.datePicker = null;
    this.getOrderActivityLogs();
  }

  onGetActivityTypeColorClassName(groupId: number) {
    switch (groupId) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 11:
      case 13:
      case 14:
      case 15:
      case 16:
      case 17:
      case 18:
      case 19:
      case 20:
      case 21:
        return 'bg_blue';
      case 9:
        return 'bg_marine';
      case 10:
        return 'bg_violet_red';
      case 12:
      case 22:
        return 'bg_yellow';
      case 23:
      case 24:
      case 25:
      case 26:
        return 'bg_green';
      default:
        return 'default_bg_color';
    }
  }

  onBack() {
    this.location.back();
  }

}
